export default "__VITE_ASSET__UjZLRsAy__"